@defer (when isGridScoreboardEnabled()) {
    @if (isGridScoreboardEnabled()) {
        <ms-my-bets-event-grid-scoreboard [event]="event()"></ms-my-bets-event-grid-scoreboard>
    }
}

@defer (when !isGridScoreboardEnabled()) {
    @if (!isGridScoreboardEnabled()) {
        <ms-my-bets-scoreboard [event]="event()"></ms-my-bets-scoreboard>
    }
}
